module.exports = __webpack_public_path__ + "assets/icons/ic_remove_circle-7bc2.svg";